"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _emotion = require("emotion");

var DEFAULT = 'default';
var LAYOUT = 'layout';
var MINIMAL = 'minimal';

var Card = function Card(_ref) {
  var children = _ref.children,
      header = _ref.header,
      isMinimal = _ref.isMinimal,
      className = _ref.className,
      style = _ref.style,
      type = _ref.type; // isMinimal should take priority here for backwards compatibility

  var cardClassName = (0, _emotion.cx)('card', className, {
    'card-minimal': isMinimal || type === MINIMAL,
    'card-layout': !isMinimal && type === LAYOUT
  });
  return _react["default"].createElement("div", {
    className: cardClassName,
    style: style
  }, header && _react["default"].createElement("div", {
    className: "card-header"
  }, _react["default"].createElement("h5", {
    className: "card-title"
  }, header)), _react["default"].createElement("div", {
    className: "card-block"
  }, children));
};

Card.propTypes = {
  children: _propTypes["default"].node.isRequired,
  header: _propTypes["default"].node,
  isMinimal: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  style: _reactStyleProptype["default"],
  type: _propTypes["default"].oneOf([DEFAULT, LAYOUT, MINIMAL])
};
Card.defaultProps = {
  header: undefined,
  isMinimal: false,
  className: '',
  style: {},
  type: DEFAULT
};
var _default = Card;
exports["default"] = _default;